<template>
    <div class="batchInput">
        <el-dialog :title="dialogTitle" :visible.sync="show" :key="show" width="80%" append-to-body @close="close">
            <el-input type="textarea" :rows="20" placeholder="请输入内容，多个以换行分隔" v-model="textarea">
            </el-input>
            <slot name="default"></slot>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确定</el-button>
                <el-button @click="close">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: ["value"],
    data() {
        return {
            //弹窗标题
            dialogTitle: "批量录入操作",
            //弹窗是否显示
            show: false,
            //选择内容集合
            textarea: ""
        }
    },
    created() {
        this.show = this.value;
    },
    mounted() {

    },
    watch: {
        "value": function (n, o) {
            this.show = n;
        },
    },
    methods: {
        submitForm() {
            let text = this.textarea;
            console.log(text);
            if (text) {
                let list = text.split(/\r?\n/) || [];
                let filterList = list.filter(x => {
                    return x && x.trim().length > 0;
                }).map(x => x.trim());
                console.log("filterList::", filterList);
                if (filterList.length > 0) {
                    this.$emit("changeInfo", filterList);
                }
            }
            this.close();
        },
        close() {
            this.textarea = "";
            this.$emit("input", false);

        },

    }
}
</script>